module.exports = __webpack_public_path__ + "static/media/success.612c77a0.svg";